// Car icons for direct display in the UI
export const carIcons = {
  // External image references to Vecteezy/Flaticon images
  // You'll need to download these images from Vecteezy or Flaticon and place them in your public/images folder
  front_windscreen: '/images/car-front-view.png',
  front_left_corner: '/images/car-front-left-corner.png',
  rear_left_corner: '/images/car-rear-left-corner.png',
  rear_right_corner: '/images/car-rear-right-corner.png',
  front_right_corner: '/images/car-front-right-corner.png',
  odometer: '/images/car-dashboard.png',
  chassis_number: '/images/car-chassis.png'
};

// Note: For the images to work, you need to:
// 1. Download royalty-free car vector images from Vecteezy or Flaticon
// 2. Place them in the public/images folder with the filenames above
// 3. Make sure the images are clear and represent each car part well
